import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
export class FileMultipleButtonLineComponent extends React.Component {
    constructor(props) {
        super(props);
        this._id = FileMultipleButtonLineComponent._IdGenerator++;
        this._uploadInputRef = React.createRef();
    }
    onChange(evt) {
        const files = evt.target.files;
        if (files && files.length) {
            this.props.onClick(evt);
        }
        evt.target.value = "";
    }
    render() {
        return (_jsxs("div", { className: "buttonLine", children: [this.props.icon && _jsx("img", { src: this.props.icon, title: this.props.iconLabel, alt: this.props.iconLabel, className: "icon" }), _jsx("label", { htmlFor: "file-upload" + this._id, className: "file-upload", children: this.props.label }), _jsx("input", { ref: this._uploadInputRef, id: "file-upload" + this._id, type: "file", accept: this.props.accept, onChange: (evt) => this.onChange(evt), multiple: true })] }));
    }
}
FileMultipleButtonLineComponent._IdGenerator = 0;
//# sourceMappingURL=fileMultipleButtonLineComponent.js.map